import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectBalance } from '../../selectors/user';
import { BalanceDesktop } from './BalanceDesktop';

export const BalanceDesktopContainer = () => {
  const balance = useSelector(selectBalance);

  return <BalanceDesktop balance={balance} />;
};
